import { FORMS_API_BASE_ENDPOINT } from "./constants";
import { api } from "./apiClient";

const BASE_ENDPOINT = `${FORMS_API_BASE_ENDPOINT}/log`;

type LogPayload = {
  userAgent: string;
  href: string;
  error: unknown;
  date: Date;
};

export const logInfo = (error: LogPayload["error"]) => {
  const payload: LogPayload = {
    userAgent: window.navigator.userAgent,
    href: location.href,
    date: new Date(),
    error: JSON.stringify(error, Object.getOwnPropertyNames(error)),
  };

  const endpoint = `${BASE_ENDPOINT}/client-information`;

  return api.post(endpoint, payload).catch(() => {});
};
